import React, {useEffect, useState} from 'react';
import Badge from 'react-bootstrap/Badge';
import ProgressBar from 'react-bootstrap/ProgressBar'
import {useParams} from "react-router-dom";
import {Table} from "react-bootstrap";
import Loading from "./Loading";

function lowMediumHigh(score: number,reverse=false) {
    if (high(score)) {
        return reverse?`(${score}%) High`:`High (${score}%)`;
    }
    if (low(score)) {
        return reverse?`(${score}%) Low`:`Low (${score}%)`;
    }
    if (med(score)) {
        return reverse?`(${score}%) Medium`:`Medium (${score}%)`;
    }
    return "?"
}

const descripitions = {
    'OPENNESS': [
        (name)=>
        `${name} tends to be excited about discovering new activities, trying new experiences, learning new skills and exploring new opportunities. 
        In other words, they usually enjoy the thrill of the unknown and challenging the status quo. 
        What got you here, will not get you there. Why not go on an adventure?`,
        (name) =>
            `${name} tends to prefer sticking to your habits and routines, enjoying the comfort of what is already known. \n` +
        '\n' +
        'Why change what works well?'
    ],
    'CONSCIENTIOUSNESS': [
        'Being carefree and easygoing',
        'Being responsible and reliable'
    ],
    'EXTROVERSION': [
        'Enjoying a more reserved and solitary life',
        'Enjoying an outgoing and social life'
    ],
    'AGREEABLENESS': [
        "Being pragmatic",
        "Being benevolent"
    ],
    'NERVOSITY': [
        "Staying optimistic and calm",
        "Focus on what could go wrong"
    ]
}
function getUserDescription(trait: string,   thisUserQR: {}, otherUserQR: {},otherUserName :string) {
    if (high(otherUserQR[trait])){
        return descripitions[trait][0](otherUserName)
    }
    if (low(otherUserQR[trait])){
        return descripitions[trait][1](otherUserName)
    }
    if (med(otherUserQR[trait])){
        if (low(thisUserQR[trait])){
            return descripitions[trait][0](otherUserName)
        }
        if (high(thisUserQR[trait])){
            return descripitions[trait][1](otherUserName)
        }
        return "both medium?"
        //if we're here it means both are medium... what to do?
    }

}

function getUserPerception(trait: string, thisUserQR: {}, otherUserQR: {}) {
    return "";
}

const caresAboutText = {
    'OPENNESS': [
        'What is known',
        'Balancing what is known with what is new',
        'What is new'
    ],
    'CONSCIENTIOUSNESS': [
        'Being carefree and easygoing',
        'Balancing a carefree life with a responsible one',
        'Being responsible and reliable'
    ],
    'EXTROVERSION': [
        'Enjoying a more reserved and solitary life',
        'Balancing solitude with social life',
        'Enjoying an outgoing and social life'
    ],
    'AGREEABLENESS': [
        "Being pragmatic",
        "Balancing being pragmatic with being benevolent",
        "Being benevolent"
    ],
    'NERVOSITY': [
        "Staying optimistic and calm",
        "Balancing optimism with concern",
        "Focus on what could go wrong"
    ]
}

function high(score: number): boolean {
    return score >= 60;
}

function med(score: number): boolean {
    return score < 60 && score > 40;
}

function low(score: number): boolean {
    return score <= 40;
}

function caresAbout(trait: string, results) {
    return high(results[trait]) ? caresAboutText[trait][2]
            : med(results[trait]) ? caresAboutText[trait][1]
            : low(results[trait]) ? caresAboutText[trait][0] : '?';
}

function CompareReport(props) {

    /*
    0. display loading screen
    1. make a call to compare profiles and get both scores
    2. classify this report and other report for each style into low/high
    3. display a comparaison

    */
    let {otherUid} = useParams();

    const [done, setDone] = useState(false);
    const [comparison, setComparison] = useState({
        thisUserQR: {},
        otherUserQR: {},
        otherUserName: ""
    });

    useEffect(() => {
        fetch('https://9ap0wh9yya.execute-api.eu-central-1.amazonaws.com/compare-profile-report', {
            method: 'POST',
            body: JSON.stringify({"otherUid": otherUid}),
            headers: {
                'Authorization': `Bearer ${props.jwt}`,
            }
        }).then(response => {
            if (response.status == 200) {
                const res = response.json();
                return res;
            }
        }).then(res => {
            console.log(res);
            setComparison({
                thisUserQR: res.thisUser['quizResults'],
                otherUserQR: res.otherQuiz['quizResults'],
                otherUserName: res.otherUserName
            });
            console.log(comparison);
            setDone(true);
        });
    }, [])


    if (done) {
        return (
            <div style={{width:'100%',height:'100%'}}><br/><br/>
                <h1>You and <b>{comparison.otherUserName}</b></h1><br/>
                <Table style={{width:'80%',margin: '0 auto'}}>
                    <thead>
                    <tr>
                        <th className="compareReportYou">{props.username}</th>
                        <th>OCEAN personality trait</th>
                        <th className="compareReportOther">{comparison.otherUserName}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <ProgressBar className="leftProgress"  variant='info' now={100} label={lowMediumHigh(comparison.thisUserQR['OPENNESS'],true)} style={{'width':comparison.thisUserQR['OPENNESS']+'%'}}/>
                        </td>
                        <td style={{width:'100px', verticalAlign:'middle'}}><h2><Badge  variant="secondary">Openness</Badge></h2></td>
                        <td>
                            <ProgressBar className="rightProgress"  variant='success' now={100} label={lowMediumHigh(comparison.otherUserQR['OPENNESS'],false)} style={{'width':comparison.otherUserQR['OPENNESS']+'%'}}/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <ProgressBar className="leftProgress"  variant='info' now={100} label={lowMediumHigh(comparison.thisUserQR['CONSCIENTIOUSNESS'],true)} style={{'width':comparison.thisUserQR['CONSCIENTIOUSNESS']+'%'}}/>
                        </td>
                        <td style={{width:'100px', verticalAlign:'middle'}}><h2><Badge  variant="secondary">Conscientiousness</Badge></h2></td>
                        <td>
                            <ProgressBar className="rightProgress"  variant='success' now={100} label={lowMediumHigh(comparison.otherUserQR['CONSCIENTIOUSNESS'],false)} style={{'width':comparison.otherUserQR['CONSCIENTIOUSNESS']+'%'}}/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <ProgressBar className="leftProgress"  variant='info' now={100} label={lowMediumHigh(comparison.thisUserQR['EXTROVERSION'],true)} style={{'width':comparison.thisUserQR['EXTROVERSION']+'%'}}/>
                        </td>
                        <td style={{width:'100px', verticalAlign:'middle'}}><h2><Badge  variant="secondary">Extroversion</Badge></h2></td>
                        <td>
                            <ProgressBar className="rightProgress"  variant='success' now={100} label={lowMediumHigh(comparison.otherUserQR['EXTROVERSION'],false)} style={{'width':comparison.otherUserQR['EXTROVERSION']+'%'}}/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <ProgressBar className="leftProgress"  variant='info' now={100} label={lowMediumHigh(comparison.thisUserQR['AGREEABLENESS'],true)} style={{'width':comparison.thisUserQR['AGREEABLENESS']+'%'}}/>
                        </td>
                        <td style={{width:'100px', verticalAlign:'middle'}}><h2><Badge  variant="secondary">Agreeableness</Badge></h2></td>
                        <td>
                            <ProgressBar className="rightProgress"  variant='success' now={100} label={lowMediumHigh(comparison.otherUserQR['AGREEABLENESS'],false)} style={{'width':comparison.otherUserQR['AGREEABLENESS']+'%'}}/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <ProgressBar className="leftProgress"  variant='info' now={100} label={lowMediumHigh(comparison.thisUserQR['NERVOSITY'],true)} style={{'width':comparison.thisUserQR['NERVOSITY']+'%'}}/>
                        </td>
                        <td style={{width:'100px', verticalAlign:'middle'}}><h2><Badge  variant="secondary">Nervosity</Badge></h2></td>
                        <td>
                            <ProgressBar className="rightProgress"  variant='success' now={100} label={lowMediumHigh(comparison.otherUserQR['NERVOSITY'],false)} style={{'width':comparison.otherUserQR['NERVOSITY']+'%'}}/>
                        </td>
                    </tr>
                    </tbody>
                </Table>
                <br />
                <h3><b>{comparison.otherUserName}</b> cares about </h3>
                <br />
                <ul style={{textAlign:'left'}}>
                    <li><b>Openness</b> : {caresAbout('OPENNESS',comparison.otherUserQR)}</li>
                    <li><b>Conscientiousness</b> : {caresAbout('CONSCIENTIOUSNESS',comparison.otherUserQR)}</li>
                    <li><b>Extroversion</b> : {caresAbout('EXTROVERSION',comparison.otherUserQR)}</li>
                    <li><b>Agreeableness</b>: {caresAbout('AGREEABLENESS',comparison.otherUserQR)}</li>
                    <li><b>Nervosity</b>: {caresAbout('NERVOSITY',comparison.otherUserQR)}</li>
                </ul>
                <br />

                <h2><b> OPENNESS TO EXPERIENCE </b></h2>

                <h3>You : {lowMediumHigh(comparison.thisUserQR['OPENNESS'])} | {comparison.otherUserName} : {lowMediumHigh(comparison.otherUserQR['OPENNESS'])}</h3>

                <div>{getUserDescription('OPENNESS', comparison.thisUserQR, comparison.otherUserQR,comparison.otherUserName)}</div>
                <br/>

                <h3> How {comparison.otherUserName} can perceive you </h3>
{/*
                <div>{getUserPerception('OPENNESS', comparison.thisUserQR,comparison.otherUserQR)}</div>
*/}

            </div>
        );
    } else {
        return (<Loading/>);
    }
}

export default CompareReport;